<script>
export default {
  data() {
    return {
      header:"header extra",
      colorTo1: "colorToOrange",
      colorTo2: "",
      colorTo3: "",
      indexUrl2:"",
      fontColor1:"",
      fontColor2:"",
      fontColor3:""
    }
  },
  mounted() {
    this.indexUrl2 = this.$route.path
    if (this.indexUrl2 === "/content") {
      this.colorTo1 = ""
      this.colorTo2 = "colorToOrange"
      this.colorTo3 = ""
      this.fontColor1="blackFont"
      this.fontColor3="blackFont"
    }
    if (this.indexUrl2 === "/about") {
      this.colorTo1 = ""
      this.colorTo2 = ""
      this.colorTo3 = "colorToOrange"
      this.fontColor1="blackFont"
      this.fontColor2="blackFont"
    }
    if (this.indexUrl2 === "/index") {
      this.colorTo1 = "colorToOrange"
      this.colorTo2 = ""
      this.colorTo3 = ""
    }
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    clickToOrange(index) {
      if (index === 1) {
        this.colorTo1 = "colorToOrange"
        this.colorTo2 = ""
        this.colorTo3 = ""
      }
      if (index === 2) {
        this.colorTo1 = ""
        this.colorTo2 = "colorToOrange"
        this.colorTo3 = ""
      }
      if (index === 3) {
        this.colorTo1 = ""
        this.colorTo2 = ""
        this.colorTo3 = "colorToOrange"
      }
    },
    handleScroll () {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop >=400 && this.indexUrl2 === "/index"){
        this.header = "header"
        this.fontColor2="blackFont"
        this.fontColor3="blackFont"
      }else if(scrollTop <400 &&  this.indexUrl2 === "/index"){
        this.header = "header extra"
        this.fontColor2="whiteFont"
        this.fontColor3="whiteFont"
      }else  if(this.indexUrl2 === "/about"){
        this.header = "header"
        this.fontColor1="blackFont"
        this.fontColor2="blackFont"
      }else  if(this.indexUrl2 === "/content"){
        this.header = "header"
        this.fontColor1="blackFont"
        this.fontColor3="blackFont"
      }
    },
  }
}
</script>

<template>
<div>
  <div  :class="header">
    <ul>
<!--      <li>-->
<!--        <img src="../../assets/logo.jpg" alt="logo">-->
<!--      </li>-->
      <li>
        <router-link to="index">
          <a @click="clickToOrange(1)" :class="colorTo1" href="javascript:(0);">
            <span :class="fontColor1">首页</span>
          </a>
        </router-link>
      </li>
      <li>
        <router-link to="content">
          <a @click="clickToOrange(2)" :class="colorTo2" href="javascript:(0);">
            <span :class="fontColor2">全心权益</span>
          </a>
        </router-link>
      </li>
      <li>
        <router-link to="about">
        <a @click="clickToOrange(3)" :class="colorTo3" href="javascript:(0);">
          <span :class="fontColor3">关于我们</span>
        </a>
        </router-link>
      </li>

    </ul>

  </div>
  <router-view></router-view>
</div>


</template>

<style>
* {
  margin-top: 0;

}

.header {
  width: 100%;
  height: 70px;
  position: fixed;
  background-color: rgba(255, 255, 255, 1);
  z-index: 999;
  border-bottom: 1px solid gainsboro;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
}
.extra{
  background-color: rgba(255, 255, 255, 0);
  border: none;
  box-shadow:none;
}
.blackFont{
  color:black;
}
.whiteFont{
  color: white;
}
ul {
  width: 100%;
  display: flex;
  justify-content: space-around;
  list-style-type: none;
}

li {
  color: #22212f;
  line-height: 70px;
  font-size: 20px;
}

a {
  text-decoration: none;
  color: white;
}

a:hover {
  color: orange;
}

.colorToOrange {
  color: orange;
}
</style>
